import React from 'react'
import ItemCodeMapping from '../components/config/ItemCodeMapping/ItemCodeMapping'

export default function ItemCodeMappingPage() {
  return (
    <div><ItemCodeMapping /></div>
  )
}
